module.exports = __webpack_public_path__ + "assets/img/nola-post.c8ed4a0d.svg";